import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import { v4 as uuidv4 } from 'uuid';
import { Oval } from "react-loader-spinner";


export default function DetailIntegration(){
    const {id} = useParams()

   const nav = useNavigate()
    
    const [selectedValue, setSelectedValue] = useState(null);
    const [detail, setDetail] = useState({})
    const [type, setType] = useState(null)
    const [key, setKey] = useState()
    const [loading, setLoading] = useState()
    const [valid, setValid] = useState()
    
    const update = async ()=>{

        try{

            setLoading(true)
            
            await api.post('update', {
               
                    id : id,
                    client : type,
                    key : key,
                    valid : valid
                
            });

            setLoading(false)
        }catch(e){
            setLoading(false)
            console.log(e)
        }
    }
    
    useEffect(()=>{

        const getKeys = async ()=>{
            
            try{

                const data = await api.get('/detail', {
                    params : {
                        id : id
                    }
                });

                setDetail(data.data);
                setType(data.data.client);
                setKey(data.data.key)
                
                
            }catch(e){

                
            }
        }
        
        getKeys()
        
    }, [])

    return(
        <div className="max-w-md mx-auto mt-10 overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800">
        
            <form className="px-6 py-4" action="" method="POST">
                <div className="mb-4">
                    <label className="block mb-2 font-bold text-gray-700 dark:text-gray-200" for="name">
                        Client
                    </label>
                    
                    <select
                        value={type}
                        onChange={(event)=>{
                            setType(event.target.value)
                        }}
                        className="block w-full px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-purple-700 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                    >
                        <option defaultValue={true} value="ADMIN">Application Administratrice</option>
                        <option value="MOBILE">Application Mobile</option>
                    </select>
                    
                </div>
                
                <div className="my-10 mb-3">

                    <div className="flex flex-row items-center justify-between flex-1">  
                        <label className="inline mb-2 font-bold text-gray-700 dark:text-gray-200" for="email">
                            key
                        </label>
                        <span
                            className="inline pt-1 pb-1 pr-2 pl-1 bg-gray-100 border-2, border-gray-200 rounded-lg ml-3 hover:cursor-pointer hover:bg-gray-700  border-2 dark:text-gray-200 dark:bg-gray-800 dark:border-gray-700"
                            onClick={()=>{
                                const newUuid = uuidv4();
                                setKey(newUuid)
                            }}
                        >
                            Generer
                        </span>

                        
                    </div>
                    <input
                        className="block w-full px-3 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-purple-700 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                        id="text" type="text" 
                        value={key}
                        readOnly
                    />
                </div>
                
                <input type="checkbox" onClick={()=>setValid(!valid)} className="mr-2 rounded-full dark:bg-gray-700 dark:border-gray-600" id="valid" checked={valid}/>
                <label id="valid" onClick={()=>setValid(!valid)} className="text-sm cursor-pointer dark:text-gray-200">{valid ? 'Valide' : 'Invalide'}</label>
            
            
                <div className="flex items-center justify-center my-4">
                    <div
                        onClick={()=>update()}
                        className="items-center w-full px-4 py-2 text-center text-white bg-purple-700 rounded hover:bg-purple-900 focus:outline-none focus:shadow-outline hover:cursor-pointer">
                            {!loading ? 'Modifier' :

                            <Oval
                                height={20}
                                width={20}
                                color="#ffffff"
                                visible={true}
                                ariaLabel="oval-loading"
                                secondaryColor="#cccccc"
                                strokeWidth={2}
                                strokeWidthSecondary={2}
                                
                            />}
                    </div>
                </div>

            </form>
        </div>
    )
}